<template>
<div class="chapter">
<div class="inner_page">
<p class="h2"><a id="page_viii"></a>CONTENTS</p>
<p class="toc"><a href="#/html/9780226077086_06_ack#ack">Acknowledgments</a></p>
<p class="toc1"><a href="#/html/9780226077086_07_int#int">Introduction</a></p>
<p class="toc-chap"><a href="#/html/9780226077086_08_ch1#ch1">1. The Social Construction of Sovereign Responsibilities</a></p>
<p class="toc-chap"><a href="#/html/9780226077086_09_ch2#ch2">2. Sovereignty in Early Modern Europe</a></p>
<p class="toc-chap"><span href="#/html/9780226077086_10_ch3#ch3" title="Link target outside of Sample">3. The Rise of Popular Sovereignty</span></p>
<p class="toc-chap"><span href="#/html/9780226077086_11_ch4#ch4" title="Link target outside of Sample">4. Sovereignty and the Non-European World</span></p>
<p class="toc-chap"><span href="#/html/9780226077086_12_ch5#ch5" title="Link target outside of Sample">5. Sovereignty after the Second World War</span></p>
<p class="toc-chap"><span href="#/html/9780226077086_13_ch6#ch6" title="Link target outside of Sample">6. The Rise of the Responsibility to Protect</span></p>
<p class="toc"><span href="#/html/9780226077086_14_con#con" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc1"><span href="#/html/9780226077086_15_not#not" title="Link target outside of Sample">Notes</span></p>
<p class="toc-chap"><span href="#/html/9780226077086_16_ref#ref" title="Link target outside of Sample">References</span></p>
<p class="toc"><span href="#/html/9780226077086_17_ind#ind" title="Link target outside of Sample">Index</span><a id="page_ix"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226077086_05_toc.vue?f940aef2